import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';

const RelatedCoins = () => {
  const [coins, setCoins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCoins = async () => {
      try {
        const res = await axios.get('https://api.coingecko.com/api/v3/coins/markets', {
          params: {
            vs_currency: 'usd',
            order: 'market_cap_desc',
            per_page: 100,
            page: 1,
          },
        });

        // Randomly shuffle the array and slice the first 3 coins
        const shuffled = res.data.sort(() => 0.5 - Math.random());
        const randomCoins = shuffled.slice(0, 3);
        setCoins(randomCoins);
      } catch (err) {
        console.error('Failed to fetch coins:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCoins();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center p-10">
        <ClipLoader color="#ffffff" />
      </div>
    );
  }

  return (
    <div className="my-12 px-4">
      <h2 className="text-3xl font-bold mb-8 text-center text-white">Related Coins</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-items-center">
        {coins.map((coin) => (
          <Link
            to={`/coins/${coin.id}`}
            key={coin.id}
            className="bg-gray-800 hover:bg-gray-700 transition duration-300 rounded-2xl shadow-lg p-6 w-full max-w-xs text-white flex flex-col items-center"
          >
            <img src={coin.image} alt={coin.name} className="w-12 h-12 mb-4" />
            <div className="text-center">
              <h3 className="font-semibold text-lg">{coin.name}</h3>
              <p className="text-sm mt-1">${coin.current_price?.toLocaleString()}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedCoins;



